import(/* webpackMode: "eager" */ "/codebuild/output/src154411709/src/smart-consumption-web/src/app/global-error.tsx");
